import React from "react";
import PropTypes from "prop-types";
import { ExpandableTextContainer, Divider } from "@qgiv/core-donor";

const ProductDescription = ({
    description,
    productDescriptionHeading,
    showLessLink,
    showMoreLink,
}) => (
    <>
        <h3>{productDescriptionHeading}</h3>
        <Divider classNames="-margin-bottom--15" />
        <ExpandableTextContainer
            showMoreLink={showMoreLink}
            showLessLink={showLessLink}
            expandableText={description}
            indented={false}
        />
    </>
);

ProductDescription.propTypes = {
    description: PropTypes.string.isRequired,
    productDescriptionHeading: PropTypes.string.isRequired,
    showLessLink: PropTypes.string.isRequired,
    showMoreLink: PropTypes.string.isRequired,
};

export default ProductDescription;
